import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowDownWideShort,
  faArrowUpShortWide,
  faArrowDownAZ,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";

const MobileSortDropdown = ({ sortableColumns, tableRows, onSort, t }) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  const currentField = tableRows?.sortCriteria?.field;
  const currentDirection = tableRows?.sortCriteria?.direction;

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (col) => {
    let sortOrder;
    if (currentField === (col.sortField || col.field)) {
      sortOrder = currentDirection === "ASC" ? -1 : 1;
    } else {
      sortOrder = 1;
    }
    onSort({ sortField: col.sortField || col.field, sortOrder });
    setIsOpen(false);
  };

  const getSortIcon = () => {
    if (!currentField) return faArrowDownAZ;
    return currentDirection === "ASC"
      ? faArrowUpShortWide
      : faArrowDownWideShort;
  };

  const currentLabel = currentField
    ? sortableColumns.find(
        (c) => c.field === currentField || c.sortField === currentField
      )?.header
    : null;

  return (
    <div className="mobile-sort-dropdown" ref={ref}>
      <button
        className={`mobile-sort-dropdown__trigger ${
          currentField ? "mobile-sort-dropdown__trigger--active" : ""
        }`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <FontAwesomeIcon icon={getSortIcon()} />
      </button>
      {isOpen && (
        <div className="mobile-sort-dropdown__menu">
          {sortableColumns.map((col) => {
            const colField = col.sortField || col.field;
            const isActive = currentField === colField;
            return (
              <button
                key={col.field}
                className={`mobile-sort-dropdown__item ${
                  isActive ? "mobile-sort-dropdown__item--active" : ""
                }`}
                onClick={() => handleSelect(col)}
              >
                <span>{col.header}</span>
                {isActive && (
                  <span className="mobile-sort-dropdown__direction">
                    <FontAwesomeIcon
                      icon={
                        currentDirection === "ASC"
                          ? faArrowUpShortWide
                          : faArrowDownWideShort
                      }
                    />
                  </span>
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MobileSortDropdown;
